import { REGULAR_MEAL_NAME, RegularMealName } from '../../../constants/mealNames';
import { getEnumArray } from '../../jsUtils';

export const getMealsListForMealsPerDay = (
  mealsPerDay: number | null,
): RegularMealName[] => {
  switch (mealsPerDay) {
    case 5:
      return getEnumArray(REGULAR_MEAL_NAME, [REGULAR_MEAL_NAME.snack1]);
    case 6:
    default:
      return getEnumArray(REGULAR_MEAL_NAME);
  }
};
